export default "__VITE_ASSET__CbLaoViR__"